<template>
  <NuxtLayout name="default" :show-search-form="false" :transparent-header="true">
    <slot />
  </NuxtLayout>
</template>
